import React from "react";
import { StyledPortfolioSoonTag } from "./styled";

const PortfolioSoonTag = () => {
  return <StyledPortfolioSoonTag>Coming soon</StyledPortfolioSoonTag>;
};

export default PortfolioSoonTag;
